import API from './api';
import formComponent from './form';

export default (MODULE) => {
  API(MODULE);
  
  const resolver = function (response) {
    if (response.data) {
      const data = response.data;
      if (data.error) return this.reject(data.error);
      return this.resolve(data);
    } else {
      throw new Error('Invalid server response');
    }
  };

  /* @ngInject */
  const resolve = {
    // pulled from legacy
    'allowed': AppCtrl.authResolver,
    'company': (allowed, $q, $rootScope) => {
      const deferred = $q.defer();
      deferred.resolve($rootScope.user.activeCompany());
      return deferred.promise;
    }
  };

  const BundleFormComponent = formComponent(MODULE);

  angular.module(MODULE)
    /* @ngInject */
    .config(($stateProvider) => {
      $stateProvider
        // .state('editPrepayment', {
        //   url: '/prepayments/:id',
        //   auth: true,
        //   component: BundleFormComponent,
        //   resolve: Object.assign(resolve, {
        //     gift: (company, $q, $transition$, GiftAPI) => {
        //       const deferred = $q.defer();
        //       const toParams = $transition$.params("to");
        //       const API = GiftAPI.req();
        //       const Gift = API.view({ id: toParams.id }).$promise;
        //       Gift.then((gift) => {

        //         if (gift.type === 'card' && !gift.electronic) {
        //           gift.shipping = gift.shipping || 2.5;
        //         }

        //         deferred.resolve(gift);
        //       });
        //       return deferred.promise;
        //     },
        //   })
        // })
        .state('newBundle', {
          url: '/bundle/new',
          auth: true,
          component: BundleFormComponent,
          resolve: Object.assign(resolve, {
            bundle: (company, $q) => {
              const deferred = $q.defer();
              deferred.resolve({});
              return deferred.promise;
            },
            hotels: (BundleAPI, company, $q) => {
              const deferred = $q.defer();
              BundleAPI.req().contacts({
                type: 'hotel'
              }).$promise.then(res => {
                deferred.resolve([{
                  _id: null,
                  name: '-- none --'
                }, ...Object.values(res.contacts)]);
              });
              return deferred.promise;
            },
            concierges: (BundleAPI, company, $q) => {
              const deferred = $q.defer();
              BundleAPI.req().contacts({
                type: 'concierge'
              }).$promise.then(res => {
                deferred.resolve([{
                  _id: null,
                  name: '-- none --'
                }, ...Object.values(res.contacts)]);
              });
              return deferred.promise;
            },
            packages: (BundleAPI, company, $q) => {
              const deferred = $q.defer();
              BundleAPI.req().packages().$promise.then(res => {
                deferred.resolve([{
                  _id: null,
                  name: '-- none --'
                }, ...res.filter(pack => pack.active)]);
              });
              return deferred.promise;
            },
            products: (BundleAPI, company, $q) => {
              const deferred = $q.defer();
              BundleAPI.req().products().$promise.then(res => {
                deferred.resolve(Object.values(res));
              });
              return deferred.promise;
            },
          })
        })
        .state('editBundle', {
          url: '/bundle/:id',
          auth: true,
          component: BundleFormComponent,
          resolve: Object.assign(resolve, {
            bundle: (BundleAPI, $stateParams, company, $q) => {
              const deferred = $q.defer();
              BundleAPI.req().view({
                id: $stateParams.id
              }).$promise.then(res => {
                deferred.resolve(res);
              });
              return deferred.promise;
            },
            hotels: (BundleAPI, company, $q) => {
              const deferred = $q.defer();
              BundleAPI.req().contacts({
                type: 'hotel'
              }).$promise.then(res => {
                deferred.resolve([{
                  _id: null,
                  name: '-- none --'
                }, ...Object.values(res.contacts)]);
              });
              return deferred.promise;
            },
            concierges: (BundleAPI, company, $q) => {
              const deferred = $q.defer();
              BundleAPI.req().contacts({
                type: 'concierge'
              }).$promise.then(res => {
                deferred.resolve([{
                  _id: null,
                  name: '-- none --'
                }, ...Object.values(res.contacts)]);
              });
              return deferred.promise;
            },
            packages: (BundleAPI, company, $q) => {
              const deferred = $q.defer();
              BundleAPI.req().packages().$promise.then(res => {
                deferred.resolve([{
                  _id: null,
                  name: '-- none --'
                }, ...res.filter(pack => pack.active)]);
              });
              return deferred.promise;
            },
            products: (BundleAPI, company, $q) => {
              const deferred = $q.defer();
              BundleAPI.req().products().$promise.then(res => {
                deferred.resolve(Object.values(res));
              });
              return deferred.promise;
            },
          })
        })
    });

};


// WEBPACK FOOTER //
// ./client/assets/scripts/modules/bundles/route.js